function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { AXIS_PARTS, isAxisProperty, isConditionalAxisValue } from '../../axis';
import { POSITION_SCALE_CHANNELS } from '../../channel';
import { getFieldOrDatumDef } from '../../channeldef';
import { getFirstDefined, isEmpty, keys, normalizeAngle } from '../../util';
import { isSignalRef } from '../../vega.schema';
import { mergeTitleComponent } from '../common';
import { guideEncodeEntry } from '../guide';
import { parseGuideResolve } from '../resolve';
import { defaultTieBreaker, mergeValuesWithExplicit } from '../split';
import { AxisComponent, AXIS_COMPONENT_PROPERTIES } from './component';
import { getAxisConfig, getAxisConfigs } from './config';
import * as encode from './encode';
import { axisRules, defaultOrient, getFieldDefTitle, getLabelAngle } from './properties';
import { guideFormat, guideFormatType } from '../format';
export function parseUnitAxes(model) {
  return POSITION_SCALE_CHANNELS.reduce(function (axis, channel) {
    if (model.component.scales[channel]) {
      axis[channel] = [parseAxis(channel, model)];
    }
    return axis;
  }, {});
}
var OPPOSITE_ORIENT = {
  bottom: 'top',
  top: 'bottom',
  left: 'right',
  right: 'left'
};
export function parseLayerAxes(model) {
  var _model$component = model.component,
    axes = _model$component.axes,
    resolve = _model$component.resolve;
  var axisCount = {
    top: 0,
    bottom: 0,
    right: 0,
    left: 0
  };
  var _iterator = _createForOfIteratorHelper(model.children),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var child = _step.value;
      child.parseAxesAndHeaders();
      var _iterator3 = _createForOfIteratorHelper(keys(child.component.axes)),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var channel = _step3.value;
          resolve.axis[channel] = parseGuideResolve(model.component.resolve, channel);
          if (resolve.axis[channel] === 'shared') {
            // If the resolve says shared (and has not been overridden)
            // We will try to merge and see if there is a conflict
            axes[channel] = mergeAxisComponents(axes[channel], child.component.axes[channel]);
            if (!axes[channel]) {
              // If merge returns nothing, there is a conflict so we cannot make the axis shared.
              // Thus, mark axis as independent and remove the axis component.
              resolve.axis[channel] = 'independent';
              delete axes[channel];
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
    // Move axes to layer's axis component and merge shared axes
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var _iterator2 = _createForOfIteratorHelper(POSITION_SCALE_CHANNELS),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _channel = _step2.value;
      var _iterator4 = _createForOfIteratorHelper(model.children),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _child = _step4.value;
          if (!_child.component.axes[_channel]) {
            // skip if the child does not have a particular axis
            continue;
          }
          if (resolve.axis[_channel] === 'independent') {
            var _axes$_channel;
            // If axes are independent, concat the axisComponent array.
            axes[_channel] = ((_axes$_channel = axes[_channel]) !== null && _axes$_channel !== void 0 ? _axes$_channel : []).concat(_child.component.axes[_channel]);
            // Automatically adjust orient
            var _iterator6 = _createForOfIteratorHelper(_child.component.axes[_channel]),
              _step6;
            try {
              for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                var axisComponent = _step6.value;
                var _axisComponent$getWit = axisComponent.getWithExplicit('orient'),
                  orient = _axisComponent$getWit.value,
                  explicit = _axisComponent$getWit.explicit;
                if (isSignalRef(orient)) {
                  continue;
                }
                if (axisCount[orient] > 0 && !explicit) {
                  // Change axis orient if the number do not match
                  var oppositeOrient = OPPOSITE_ORIENT[orient];
                  if (axisCount[orient] > axisCount[oppositeOrient]) {
                    axisComponent.set('orient', oppositeOrient, false);
                  }
                }
                axisCount[orient]++;
                // TODO(https://github.com/vega/vega-lite/issues/2634): automatically add extra offset?
              }
            } catch (err) {
              _iterator6.e(err);
            } finally {
              _iterator6.f();
            }
          }
          // After merging, make sure to remove axes from child
          delete _child.component.axes[_channel];
        }
        // Show gridlines for first axis only for dual-axis chart
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      if (resolve.axis[_channel] === 'independent' && axes[_channel] && axes[_channel].length > 1) {
        var _iterator5 = _createForOfIteratorHelper((axes[_channel] || []).entries()),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _ref = _step5.value;
            var _ref2 = _slicedToArray(_ref, 2);
            var index = _ref2[0];
            var axisCmpt = _ref2[1];
            if (index > 0 && !!axisCmpt.get('grid') && !axisCmpt.explicit.grid) {
              axisCmpt.implicit.grid = false;
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}
function mergeAxisComponents(mergedAxisCmpts, childAxisCmpts) {
  if (mergedAxisCmpts) {
    // FIXME: this is a bit wrong once we support multiple axes
    if (mergedAxisCmpts.length !== childAxisCmpts.length) {
      return undefined; // Cannot merge axis component with different number of axes.
    }
    var length = mergedAxisCmpts.length;
    for (var i = 0; i < length; i++) {
      var merged = mergedAxisCmpts[i];
      var child = childAxisCmpts[i];
      if (!!merged !== !!child) {
        return undefined;
      } else if (merged && child) {
        var mergedOrient = merged.getWithExplicit('orient');
        var childOrient = child.getWithExplicit('orient');
        if (mergedOrient.explicit && childOrient.explicit && mergedOrient.value !== childOrient.value) {
          // TODO: throw warning if resolve is explicit (We don't have info about explicit/implicit resolve yet.)
          // Cannot merge due to inconsistent orient
          return undefined;
        } else {
          mergedAxisCmpts[i] = mergeAxisComponent(merged, child);
        }
      }
    }
  } else {
    // For first one, return a copy of the child
    return childAxisCmpts.map(function (axisComponent) {
      return axisComponent.clone();
    });
  }
  return mergedAxisCmpts;
}
function mergeAxisComponent(merged, child) {
  var _iterator7 = _createForOfIteratorHelper(AXIS_COMPONENT_PROPERTIES),
    _step7;
  try {
    var _loop = function _loop() {
      var prop = _step7.value;
      var mergedValueWithExplicit = mergeValuesWithExplicit(merged.getWithExplicit(prop), child.getWithExplicit(prop), prop, 'axis',
      // Tie breaker function
      function (v1, v2) {
        switch (prop) {
          case 'title':
            return mergeTitleComponent(v1, v2);
          case 'gridScale':
            return {
              explicit: v1.explicit,
              // keep the old explicit
              value: getFirstDefined(v1.value, v2.value)
            };
        }
        return defaultTieBreaker(v1, v2, prop, 'axis');
      });
      merged.setWithExplicit(prop, mergedValueWithExplicit);
    };
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }
  return merged;
}
function isExplicit(value, property, axis, model, channel) {
  if (property === 'disable') {
    return axis !== undefined; // if axis is specified or null/false, then its enable/disable state is explicit
  }
  axis = axis || {};
  switch (property) {
    case 'titleAngle':
    case 'labelAngle':
      return value === (isSignalRef(axis.labelAngle) ? axis.labelAngle : normalizeAngle(axis.labelAngle));
    case 'values':
      return !!axis.values;
    // specified axis.values is already respected, but may get transformed.
    case 'encode':
      // both VL axis.encoding and axis.labelAngle affect VG axis.encode
      return !!axis.encoding || !!axis.labelAngle;
    case 'title':
      // title can be explicit if fieldDef.title is set
      if (value === getFieldDefTitle(model, channel)) {
        return true;
      }
  }
  // Otherwise, things are explicit if the returned value matches the specified property
  return value === axis[property];
}
/**
 * Properties to always include values from config
 */
var propsToAlwaysIncludeConfig = new Set(['grid',
// Grid is an exception because we need to set grid = true to generate another grid axis
'translate',
// translate has dependent logic for bar's bin position and it's 0.5 by default in Vega. If a config overrides this value, we need to know.
// the rest are not axis configs in Vega, but are in VL, so we need to set too.
'format', 'formatType', 'orient', 'labelExpr', 'tickCount', 'position', 'tickMinStep']);
function parseAxis(channel, model) {
  var _axis, _config, _config$axis, _axis2, _axis$encoding;
  var axis = model.axis(channel);
  var axisComponent = new AxisComponent();
  var fieldOrDatumDef = getFieldOrDatumDef(model.encoding[channel]);
  var mark = model.mark,
    config = model.config;
  var orient = ((_axis = axis) === null || _axis === void 0 ? void 0 : _axis.orient) || ((_config = config[channel === 'x' ? 'axisX' : 'axisY']) === null || _config === void 0 ? void 0 : _config.orient) || ((_config$axis = config.axis) === null || _config$axis === void 0 ? void 0 : _config$axis.orient) || defaultOrient(channel);
  var scaleType = model.getScaleComponent(channel).get('type');
  var axisConfigs = getAxisConfigs(channel, scaleType, orient, model.config);
  var disable = axis !== undefined ? !axis : getAxisConfig('disable', config.style, (_axis2 = axis) === null || _axis2 === void 0 ? void 0 : _axis2.style, axisConfigs).configValue;
  axisComponent.set('disable', disable, axis !== undefined);
  if (disable) {
    return axisComponent;
  }
  axis = axis || {};
  var labelAngle = getLabelAngle(fieldOrDatumDef, axis, channel, config.style, axisConfigs);
  var formatType = guideFormatType(axis.formatType, fieldOrDatumDef, scaleType);
  var format = guideFormat(fieldOrDatumDef, fieldOrDatumDef.type, axis.format, axis.formatType, config, true);
  var ruleParams = {
    fieldOrDatumDef: fieldOrDatumDef,
    axis: axis,
    channel: channel,
    model: model,
    scaleType: scaleType,
    orient: orient,
    labelAngle: labelAngle,
    format: format,
    formatType: formatType,
    mark: mark,
    config: config
  };
  // 1.2. Add properties
  var _iterator8 = _createForOfIteratorHelper(AXIS_COMPONENT_PROPERTIES),
    _step8;
  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var property = _step8.value;
      var value = property in axisRules ? axisRules[property](ruleParams) : isAxisProperty(property) ? axis[property] : undefined;
      var hasValue = value !== undefined;
      var explicit = isExplicit(value, property, axis, model, channel);
      if (hasValue && explicit) {
        axisComponent.set(property, value, explicit);
      } else {
        var _ref3 = isAxisProperty(property) && property !== 'values' ? getAxisConfig(property, config.style, axis.style, axisConfigs) : {},
          _ref3$configValue = _ref3.configValue,
          configValue = _ref3$configValue === void 0 ? undefined : _ref3$configValue,
          _ref3$configFrom = _ref3.configFrom,
          configFrom = _ref3$configFrom === void 0 ? undefined : _ref3$configFrom;
        var hasConfigValue = configValue !== undefined;
        if (hasValue && !hasConfigValue) {
          // only set property if it is explicitly set or has no config value (otherwise we will accidentally override config)
          axisComponent.set(property, value, explicit);
        } else if (
        // Cases need implicit values
        // 1. Axis config that aren't available in Vega
        !(configFrom === 'vgAxisConfig') ||
        // 2. Certain properties are always included (see `propsToAlwaysIncludeConfig`'s declaration for more details)
        propsToAlwaysIncludeConfig.has(property) && hasConfigValue ||
        // 3. Conditional axis values and signals
        isConditionalAxisValue(configValue) || isSignalRef(configValue)) {
          // If a config is specified and is conditional, copy conditional value from axis config
          axisComponent.set(property, configValue, false);
        }
      }
    }
    // 2) Add guide encode definition groups
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }
  var axisEncoding = (_axis$encoding = axis.encoding) !== null && _axis$encoding !== void 0 ? _axis$encoding : {};
  var axisEncode = AXIS_PARTS.reduce(function (e, part) {
    var _axisEncoding$part;
    if (!axisComponent.hasAxisPart(part)) {
      // No need to create encode for a disabled part.
      return e;
    }
    var axisEncodingPart = guideEncodeEntry((_axisEncoding$part = axisEncoding[part]) !== null && _axisEncoding$part !== void 0 ? _axisEncoding$part : {}, model);
    var value = part === 'labels' ? encode.labels(model, channel, axisEncodingPart) : axisEncodingPart;
    if (value !== undefined && !isEmpty(value)) {
      e[part] = {
        update: value
      };
    }
    return e;
  }, {});
  // FIXME: By having encode as one property, we won't have fine grained encode merging.
  if (!isEmpty(axisEncode)) {
    axisComponent.set('encode', axisEncode, !!axis.encoding || axis.labelAngle !== undefined);
  }
  return axisComponent;
}